import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/faq/components/FAQContent.tsx");
